import { type InventoryResource } from "@@/shared/acquire/resources/inventory-resource";
import type {
    ResourceFoundation,
    ResourceFoundationData,
} from "@@/shared/acquire/resources/resource-foundation";
import type { Except } from "type-fest";

//? Moved here because of circulation

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceFoundation = (item: any): item is ResourceFoundation => {
    return item?._type === "RESOURCE_FOUNDATION";
};

type ResourceFoundationOf<T extends InventoryResource> = Except<
    ResourceFoundation,
    "data"
> & {
    data: ResourceFoundationData<T["_type"]>;
};
const isResourceFoundationOf =
    <T extends InventoryResource>(ofType: T["_type"]) =>
    (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        foundation: any,
    ): foundation is ResourceFoundationOf<T> => {
        return (
            !!foundation &&
            isResourceFoundation(foundation) &&
            foundation.data._type === ofType
        );
    };

export { isResourceFoundation, isResourceFoundationOf };

export type { ResourceFoundationOf };
